import { render, staticRenderFns } from "./CapturePassport.vue?vue&type=template&id=624dddbb&scoped=true&"
import script from "./CapturePassport.vue?vue&type=script&lang=ts&"
export * from "./CapturePassport.vue?vue&type=script&lang=ts&"
import style0 from "./CapturePassport.vue?vue&type=style&index=0&id=624dddbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624dddbb",
  null
  
)

export default component.exports